<template>
  <b-modal id="paymentModal" :title="title" size="lg" @shown="fn_show_payment">
    <div class="flex items-center justify-between mb20">
      <p>
        선택하신 주문 <strong class="fwb" style="color: red">{{paymentListInfo.length}}</strong>건의
        결제를 진행해주세요.
      </p>
      <button class="btn btn_md btn_deepbrown" @click="fn_open_bundle">묶음배송</button>
    </div>
    <div class="search user_modal">
      <div
        class="table_list mb30"
        style="
          max-height: 250px;
          height: 250px;
          overflow: hidden;
          overflow-y: auto;
        "
      >
        <table class="list no_view text-sm">
          <colgroup>
            <col width="100" />
            <col width="50" />
            <col width="100" />
            <col width="*" />
            <col width="100" />
            <col width="50" />
            <col width="50" />
            <col width="200" />
            <col width="50" />
          </colgroup>
          <thead>
            <tr>
                <th>처방번호</th>
                <th>분류</th>
                <th>환자명</th>
                <th>처방명</th>
                <th>총비용</th>
                <th>첩수</th>
                <th>팩수</th>
                <th>처방일자</th>
                <th>묶음배송</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in paymentListInfo"
              :key="index"                    
            >
              <td>
                <span>{{ item.prescribe_seq }}</span>
              </td>
              <td>
                <span v-if="item.prescribe_type == 'T'" class="font_orange">탕전</span>
                <span v-if="item.prescribe_type == 'I'" class="font_green">첩약</span>
                <span v-if="item.prescribe_type == 'P'" class="font_blue">약속</span>
              </td>
              <td>
                <span>{{ item.patient_nm }}</span>
              </td>
              <td class="al">
                <span>{{ item.prescribe_nm }}</span><span v-if="item.prescribe_type == 'P'">× {{item.item_quantity}} </span>
              </td>
              <td>
                <span>{{ fn_comma_won(item.total_payment) }}</span>
              </td>
              <td>
                <span>{{ fn_comma_won(item.prescribe_pack_cnt) }}</span>
              </td>
              <td>
                <span>{{ fn_comma_won(item.packs_cnt) }}</span>
              </td>
              <td>
                <span>{{ item.reg_dt }}</span>
              </td>
              <td>
                <b-badge
                  v-if="item.is_combined == 'Y'"
                  class="pointer"
                  :variant="item.combined_type === 'M' ? 'warning' : 'dark'"
                  v-b-modal.bundleModal
                >
                  {{ item.combined_type === "M" ? "묶음" : "묶임" }}
                </b-badge>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table_list">
        <div class="modal_table user" style="height: auto">
          <table class="write text-sm">
            <colgroup>
              <col width="140" />
              <col width="400" />
              <col width="140" />
              <col width="400" />
            </colgroup>
            <tbody>
              <tr>
                <th>주문 합계</th>
                <td>
                  <span
                    v-for="(price, idx) in paymentListInfo"
                    :key="price.key"
                  >
                    {{ idx > 0 ? '+ ' : '' }}
                    {{ price.prescribe_nm }}({{ price.prescribe_seq }}) {{ formatPrice(price.total_payment) }}
                  </span>
                </td>
                <th>합계 금액</th>
                <td class="ar">
                  <span>{{ fn_comma_won(this.total_order_price) }}</span>
                </td>
              </tr>
              <tr>
                <th>예치금 차감액</th>
                <td>
                  <div class="form_inline flex">
                    <input
                      type="text"
                      class="form_control"
                      placeholder="입력하세요"
                      v-model="deposit_use_price"
                      @change="fn_use_deposit_point_change"
                    />
                    <button class="btn btn_md btn_darkbrown" @click="fn_all_use_deposit">
                      전체금액사용
                    </button>
                  </div>
                </td>
                <th>예치금 잔액</th>
                <td class="ar">
                  <span>{{fn_comma_won(depositPointInfo.deposit_balance)}} 원</span>
                </td>
              </tr>
              <tr>
                <th>코끼리포인트 차감액</th>
                <td>
                  <div class="form_inline flex">
                    <input
                      type="text"
                      class="form_control"
                      placeholder="입력하세요"
                      v-model="point_use_price"
                      @change="fn_use_deposit_point_change"
                    />
                    <button class="btn btn_md btn_darkbrown" @click="fn_all_use_point">
                      최대포인트사용
                    </button>
                  </div>
                </td>
                <th>코끼리 잔여 포인트</th>
                <td class="ar">
                  <span>[최대사용가능 포인트 : {{fn_comma_won(max_use_point)}}] {{fn_comma_won(depositPointInfo.point_balance)}} 점</span>
                </td>
              </tr>
              <tr>
                <th>총 결제 금액</th>
                <td>
                  <span>
                    상품 금액 {{ fn_comma_won(total_order_price) }} 원 - 예치금 {{fn_comma_won(deposit_use_price)}} 원- 코끼리포인트 {{fn_comma_won(point_use_price)}} 원
<!--                    <strong style="color: red">-->
<!--                      할인금액 0 원- 배송비 할인 금액 0 원 -->
<!--                    </strong>-->
                  </span>
                </td>
                <th>결제 예정금액</th>
                <td class="ar">
                  <span style="font-size: 20px; color: #78420c" class="fwb">
                    {{ fn_comma_won(total_payment_price) }}
                  </span>
                  원
                </td>
              </tr>
              <tr>
                <th><span class="emp">결제방식</span></th>
                <td>
                  <div class="form_radio">
                    <input type="radio" id="radio1" name="radio" checked />
                    <label for="radio1" style="justify-content: flex-start">
                      선불결제
                    </label>
                  </div>
                </td>
                <th><span class="emp">결제수단 선택</span></th>
                <td>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input type="radio" id="radio2" name="radios" checked />
                      <label for="radio2" style="justify-content: flex-start">
                        신용카드
                      </label>
                    </div>
                    <div class="form_radio">
                      <input type="radio" id="radio3" name="radios" checked />
                      <label for="radio3" style="justify-content: flex-start">
                        무통장입금
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="txt_info">
      * 결제가 완료되지 않으면 탕전실에 처방전이 접수되지 않아 조제가 시작되지
      않습니다.
    </div>
    <template #modal-footer>
      <b-button @click="fn_payment" class="btn btn_md btn_brown"> 결제하기</b-button>
    </template>

    <alert-modal 
      :id="'alert'"
      :text="showAlertMsg" 
      :btnRight="'확인'" 
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      @closeEvent="oncCloseEvent"
      v-on:update:showSetting="fn_showSet"
    />
  </b-modal>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  name: "paymentModal",
  props: {
    title: String,
    paymentListInfo : []
  },
    components: {
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      selected: null,
      // 체크된 prescribe_seq 목록
      checkedSeqs: [],

      // 선택된 항목만 필터링해서 담는 리스트
      selectedList: [],

      //총 주문 금액
      total_order_price : 0,

      //예치금 사용금액
      deposit_use_price : 0,

      //포인트 사용금액
      point_use_price : 0,

      // 최대 포인트 사용금액
      max_use_point : 0,

      //총 결제 금액
      total_payment_price : 0,

      // 예치금, 포인트 정보
      depositPointInfo : {}
    };
  },
  methods : {

    sum_payment_price() {
      if (!this.paymentListInfo) return 0;

      let total_price =  this.paymentListInfo.reduce((sum, p) => {
        const val = Number(p.total_payment);
        return isNaN(val) ? sum : sum + val;
      }, 0);

      this.total_order_price = total_price;
      this.fn_total_payment_price();
      
      return this.fn_comma_won(total_price);
      
    },
    formatPrice(val) {
      return Number(val).toLocaleString();
    },
    fn_open_bundle(){
      this.$bvModal.hide('paymentModal');

      this.$bvModal.show('bundleModal');
    },
    fn_total_payment_price(){
      this.total_payment_price = this.total_order_price - this.deposit_use_price - this.point_use_price;
    },
    async fn_show_payment(){

      this.deposit_use_price = 0;
      this.point_use_price = 0;
      this.total_payment_price = 0;

      //예치금, 포인트 정보 가져오기
      await this.fn_search_DepositPointInfo();
      await this.sum_payment_price();
      await this.fn_max_point_count();
    },
    fn_payment(){

      let param = new Object();
      param.paymentList = this.paymentListInfo;
      param.deposit_use_price = this.deposit_use_price;
      param.point_use_price = this.point_use_price;

      console.log("결제정보 : %o",param);

      // 임시방편 - 예치금, 포인트로만 결재 가능
      if(this.total_payment_price > 0){
        let msg = "현재는 예치금과 포인트로만 결제가 가능합니다.";
        this.fn_open_alert(msg);
        return;
      }

      axios
        .post("/api/user/mypage/paymentCompleted", param)
        .then((res) => {
            
            let msg = "결제가 완료되었습니다..";
            this.fn_open_alert_close(msg); 

        })
        .catch((err) => console.log(err));
    },
    oncCloseEvent(){

      this.$bvModal.hide('paymentModal');

      // 결제 정보 부모창 갱신
      this.$emit('update-payment');
    },
    async fn_search_DepositPointInfo(){
      // 예치금, 포인트 정보 가져오기
      let param = new Object();
      param.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

      await axios
            .post("/api/user/mypage/getDepositPointInfo", param)
            .then((res) => {
                this.depositPointInfo = res.data.depositPointInfo;
            })
            .catch((err) => console.log(err));
    },
    fn_all_use_deposit(){
      //예치금 잔액이 결제금액보다 클때
      if(this.total_payment_price < this.depositPointInfo.deposit_balance){
        this.deposit_use_price = this.total_order_price - this.point_use_price;
      }else{
        this.deposit_use_price = this.depositPointInfo.deposit_balance;
      }

      this.fn_total_payment_price();
    },
    fn_use_deposit_point_change(){
      this.fn_total_payment_price();
    },
    fn_all_use_point(){
      let max_point =  Number(Math.trunc(this.total_order_price  * 0.3));

      if((this.total_order_price - this.deposit_use_price) > 0 && this.total_payment_price > 0) {
        if(max_point <= this.total_payment_price ){
          // 최대포인트사용은 총금액에서 예치금 사용액을 뺀 금액의 20%
          this.point_use_price = this.max_use_point;
        }else{
          this.point_use_price = this.total_payment_price;
        }
      }

      this.fn_total_payment_price();
    },
    fn_max_point_count(){
      let max_point =  Number(Math.trunc(this.total_order_price  * 0.3));

       if(max_point < this.total_order_price) {

         let balance_point = Number(this.depositPointInfo.point_balance);

         //최대 사용 포인트는 총금액의 20%와 보유 포인트 중 작은 포인트 점수 표시
         if(max_point > balance_point){
           this.max_use_point =  balance_point;
         }else{
           this.max_use_point =  max_point;
         }
       }else{
         this.max_use_point = this.total_order_price;
       }
    }
  }
};
</script>

<style></style>
